<template>
  <v-row justify="center" class="ma-0">
    <v-col cols="12" class="pa-0">
      <template v-if="mode !='view'">
        <v-col cols="12" class="pa-0">
          <v-toolbar height="60" dark color="primary">
            <v-toolbar-title class="white--text pl-2">{{ myItem.title }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn rounded depressed small @click.stop="changeStatus()" color="white" :class="myItem.enable ? 'primary--text font-weight-bold' : 'error--text font-weight-bold'">{{ myItem.enable ? '公開' : '非公開' }}</v-btn>
          </v-toolbar>
        </v-col>
        <v-card>
          <v-card-text class="pa-1 overflow-y-auto" :style="dialogHeight">
            <v-row justify="center" class="ma-0">
              <v-col cols="6" class="py-0">
                <v-row justify="center" class="ma-0">
                  <v-col cols="12" class="pa-0">
                    <v-select
                      ref="type"
                      :items="myNotices"
                      label="*種別"
                      v-model.number="myItem.type"
                      item-text="name"
                      item-value="key"
                      :rules="[rules.required]"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" class="pa-0">
                    <v-row align="center" class="ma-0 pa-0">
                      <v-col cols="6" class="pa-0">
                        <template-date-picker
                          :id="3"
                          :icon="'event'"
                          :date="myItem.date"
                          :label="'日付'"
                          :title="false"
                          @updated="onUpdated"
                        ></template-date-picker>
                      </v-col>
                      <v-col cols="4" class="pa-0">
                        <template-time-picker
                          :id="1"
                          :icon="'access_time'"
                          :time="myItem.time"
                          :label="'時刻'"
                          @updated="onUpdated"
                        ></template-time-picker>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="pa-0">
                    <v-text-field
                      ref="title"
                      v-model="myItem.title"
                      :rules="[rules.required]"
                      label="*名称"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="pa-0">
                    <v-textarea
                      name="description"
                      prepend-inner-icon="mdi-pencil-box"
                      label="概要"
                      v-model="myItem.description"
                      outlined
                    >
                    </v-textarea>
                  </v-col>
                  <template v-if="myItem.type && myItem.type != 3">
                    <v-col cols="12" class="pa-0">
                      <v-select
                        :items="shares"
                        label="資料"
                        v-model="doc"
                        item-text="name"
                        item-value="key"
                        small-chips
                      ></v-select>
                    </v-col>
                  </template>
                  <template v-if="myItem.type == 1">
                    <v-col cols="12" class="pa-0">
                      <v-row class="ma-0 pa-0" align="center">
                        <v-col cols="11" class="pa-0">
                          <v-select
                            :items="locations"
                            label="場所"
                            v-model="location"
                            item-text="name"
                            item-value="key"
                            class="caption"
                          ></v-select>
                        </v-col>
                        <v-col class="pa-0" align="end">
                          <v-btn icon small depressed @click="mapsDialog = true"><v-icon color="primary">mdi-map-marker-plus</v-icon></v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="pa-0">
                      <v-text-field
                        ref="url"
                        v-model="myItem.url"
                        label="申込サイト"
                      ></v-text-field>
                    </v-col>
                  </template>
                  <v-col cols="12" class="py-0">
                    <v-select
                      ref="charge"
                      prepend-icon="mdi-account-circle-outline"
                      :items="scopes"
                      label="範囲"
                      v-model="myScope"
                      dense
                      auto-grow
                      multiple
                      item-text="name"
                      item-value="key"
                      class="caption"
                      small-chips
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6" class="pa-0">
                <template-notice-preview
                  :item.sync="myItem"
                  :mode="mode"
                  @dismissed="close"
                >
                </template-notice-preview>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded depressed @click="close">取消</v-btn>
            <v-btn rounded depressed color="primary" @click.native="onSubmitDialog()">{{ getButtonLable() }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
      <template v-else>
        <template-notice-preview
          :item="item"
          :mode="mode"
          :change="change"
          @dismissed="close"
        >
        </template-notice-preview>
      </template>
    </v-col>

    <div>
      <app-basic-dialog
        v-if='submit'
        @dismissed="onDismissed"
        :title="'告知'"
        :message="'告知を登録します。よろしいですか?'"
        :dialog='submit'
        :color="'primary'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-basic-dialog
        v-if='privError'
        @dismissed="onDismissed"
        :title="'権限'"
        :message="'特権モードで操作をしてください'"
        :dialog='privError'
        :color="'primary'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <v-dialog v-model="mapsDialog"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <app-google-maps
          v-if="mapsDialog"
          @dismissed="onDismissed"
          :dialog='mapsDialog'
          :location="location"
        >
        </app-google-maps>
      </v-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import GoogleMapsDialog from '../../components/google/GoogleMapsDialog.vue'
import NoticePreview from './NoticePreview.vue'
Vue.component('app-google-maps', GoogleMapsDialog)
Vue.component('template-notice-preview', NoticePreview)
export default {
  data () {
    return {
      mapsDialog: false,
      submit: false,
      privError: false,
      loading: false,
      myItem: null,
      location: null,
      doc: null,
      change: '',
      scopes: [],
      myScope: null,
      rules: {
        required: value => !!value || 'Required.'
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      locations: 'locations/locations',
      templateTasks: 'templateTasks/templates',
      shares: 'shares/shares',
      windowSize: 'shared/windowSize'
    }),
    form () {
      return {
        type: this.myItem.type,
        title: this.myItem.title
      }
    },
    myNotices () {
      var temp = []
      for (var i in this.$NOTICE_TYPE) {
        if (this.data.role === 'admin' && this.data.root) {
          if (this.$NOTICE_TYPE[i].admin) {
            temp.push(this.$NOTICE_TYPE[i])
          }
        } else {
          if (!this.$NOTICE_TYPE[i].admin) {
            temp.push(this.$NOTICE_TYPE[i])
          }
        }
      }
      return temp
    },
    dialogHeight () {
      var h = Math.round(this.windowSize.y * 0.6)
      h = h > 700 ? 700 : h
      return 'max-height: ' + String(h) + 'px; overflow-x: hidden;'
    }
  },
  watch: {
    location () {
      Vue.set(this.myItem.contents, 'location', this.location)
    },
    doc () {
      Vue.set(this.myItem.contents, 'doc', this.doc)
    },
    myScope () {
      if (this.myScope.indexOf('*') !== -1) {
        for (var i in this.scopes) {
          if (this.scopes[i].key !== '*') {
            this.scopes[i].disabled = true
          }
        }
      } else {
        for (i in this.scopes) {
          if (this.scopes[i].key !== '*') {
            this.scopes[i].disabled = false
          } else {
            if (this.myScope.length !== 0) {
              this.scopes[i].disabled = true
            } else {
              this.scopes[i].disabled = false
            }
          }
        }
      }
    }
  },
  props: [ 'mode', 'item', 'dialog' ],
  created () {
    this.myItem = this.item ? this.item : JSON.parse(JSON.stringify(this.$store.getters['notices/initial']))
    if (typeof this.myItem.enable === 'undefined') {
      this.myItem['enable'] = false
    }
    this.location = this.myItem.contents.location ? this.myItem.contents.location : null
    this.doc = this.myItem.contents.doc ? this.myItem.contents.doc : null
    this.createScopes()
  },
  methods: {
    createScopes () {
      this.scopes = [
        { type: 'school',
          name: '全塾',
          key: '*',
          item: null,
          disabled: false
        }
      ]
      this.myScope = []
      if (!this.data) {
        return
      }
      for (var i in this.schools) {
        this.scopes.push({
          type: 'school',
          name: this.schools[i].name,
          key: this.schools[i].key,
          item: this.schools[i],
          disabled: false
        })
      }
      var keys = Object.keys(this.myItem.schools)
      for (i in keys) {
        if (this.myItem.schools[keys[i]]) {
          this.myScope.push(keys[i])
        }
      }
    },
    changeStatus () {
      var status = this.myItem.enable
      Vue.set(this.myItem, 'enable', !status)
    },
    getButtonLable () {
      return this.myItem.key ? '更新' : '新規登録'
    },
    onUpdated: function (value) {
      switch (value.id) {
        case 1:
          this.myItem.time = value.time
          break
        case 3:
          this.myItem.date = value.date
          break
      }
    },
    onSubmitDialog () {
      this.formHasErrors = false
      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) {
          this.formHasErrors = true
        }
        this.$refs[f].validate(true)
      })
      if (this.myItem.type === 3) {
        if (!this.data.root) {
          this.privError = true
          return
        }
      }
      if (!this.formHasErrors) {
        this.submit = true
      }
    },
    onSubmit () {
      var vm = this
      this.submit = false
      vm.loading = true
      this.$nextTick(function () {
        var payload = JSON.parse(JSON.stringify(this.myItem))
        payload.contents = {
          location: this.location,
          doc: this.doc
        }
        payload.charge = this.user.uid
        var s = {}
        for (var i in this.myScope) {
          s[this.myScope[i]] = true
        }
        payload.schools = s
        if (!payload.key) {
          payload.createdAt = parseInt(new Date().getTime())
        }
        payload.updatedAt = parseInt(new Date().getTime())
        vm.$store.dispatch('notices/write', JSON.parse(JSON.stringify(payload))).then((resp) => {
          vm.loading = false
          this.close()
        })
      })
    },
    close () {
      this.$emit('dismissed', null)
    },
    onDismissed: function (value) {
      if (this.submit) {
        this.submit = false
        if (value) {
          this.onSubmit()
        }
        return
      }
      if (this.privError) {
        this.privError = false
        return
      }
      this.mapsDialog = false
    }
  }
}
</script>
